import { api } from "../../../api";
import { TMSWhsResponseProp, RequestTmsWhsParams } from "../types";

export async function getLoadingWhsListApi(
  params: RequestTmsWhsParams,
): Promise<TMSWhsResponseProp> {
  const { data } = await api.get<TMSWhsResponseProp>(`/api/loadings-whs`, {
    params,
  });
  return data;
}

export async function exportLiteTmsWhsApi(
  params?: Partial<RequestTmsWhsParams>,
): Promise<{
  file: Blob;
  filename: string;
}> {
  const response = await api.get(`/api/loadings-whs/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}
